export const BASE_URL =
  "https://sjcx9ybduc.execute-api.ap-south-1.amazonaws.com/Prod";

